import React, { useState } from 'react';
import './TrialBanner.css';

function TrialBanner({ subscription, onUpgrade }) {
  const [dismissed, setDismissed] = useState(() => {
    // Check if dismissed today
    const dismissedDate = localStorage.getItem('trial-banner-dismissed');
    if (dismissedDate) {
      const today = new Date().toDateString();
      return dismissedDate === today;
    }
    return false;
  });

  if (!subscription || subscription.plan !== 'trial' || dismissed) {
    return null;
  }

  const trialEnd = new Date(subscription.trial_ends_at);
  const now = new Date();
  const daysLeft = Math.ceil((trialEnd - now) / (1000 * 60 * 60 * 24));

  if (daysLeft <= 0) {
    return null;
  }

  const handleDismiss = () => {
    localStorage.setItem('trial-banner-dismissed', new Date().toDateString());
    setDismissed(true);
  };

  const urgencyClass = daysLeft <= 2 ? 'urgent' : daysLeft <= 4 ? 'warning' : '';

  return (
    <div className={`trial-banner ${urgencyClass}`}>
      <button className="trial-banner-dismiss" onClick={handleDismiss}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
      <div className="trial-banner-content">
        <div className="trial-banner-days">
          <span className="trial-days-number">{daysLeft}</span>
          <span className="trial-days-label">{daysLeft === 1 ? 'day' : 'days'} left</span>
        </div>
        <p className="trial-banner-message">in your free trial</p>
      </div>
      <button className="trial-banner-button" onClick={onUpgrade}>
        Sign Up
      </button>
    </div>
  );
}

export default TrialBanner;
